module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/empire-96d8fc18749eb09e42e0d904fddd6edc.jpg";